<ng-content [select]="'[slot=container-start]'"></ng-content>
@if(navigation && showNavigation) {
<div class="swiper-button-prev"
     #prevElRef></div>
<div class="swiper-button-next"
     #nextElRef></div>
}
<div [ngClass]="wrapperClass"
     [attr.id]="id">
    <ng-content [select]="'[slot=wrapper-start]'"></ng-content>
    <ng-template *ngTemplateOutlet="
      slidesTemplate;
      context: {
        loopSlides: prependSlides,
        key: 'prepend'
      }
    "></ng-template>
    <ng-template *ngTemplateOutlet="
      slidesTemplate;
      context: {
        loopSlides: activeSlides,
        key: ''
      }
    "></ng-template>
    <ng-template *ngTemplateOutlet="
      slidesTemplate;
      context: {
        loopSlides: appendSlides,
        key: 'append'
      }
    "></ng-template>
    <ng-content [select]="'[slot=wrapper-end]'"></ng-content>
</div>

@if(scrollbar && showScrollbar) {
<div class="swiper-scrollbar"
     #scrollbarElRef></div>
}
@if(pagination && showPagination) {
<div class="swiper-pagination"
     #paginationElRef></div>
}

<ng-content [select]="'[slot=container-end]'"></ng-content>

<ng-template #slidesTemplate
             let-loopSlides="loopSlides"
             let-slideKey="key">
    @for (slide of (loopSlides | async) ; track slide) {
    <div [ngClass]="getSlideClass(slide, slideKey)"
         [attr.data-swiper-slide-index]="slide.virtualIndex ? slide.virtualIndex : slide.slideIndex"
         [attr.data-swiper-autoplay]="slide.autoplayDelay"
         [style]="getSlideStyle(slide)">
        @if(slide.zoom) {
        <div [ngClass]="zoomContainerClass">
            <ng-template [ngTemplateOutlet]="slide.template"
                         [ngTemplateOutletContext]="{
          $implicit: slide.slideData
        }"></ng-template>
        </div>
        }@else {
        <ng-template [ngTemplateOutlet]="slide.template"
                     [ngTemplateOutletContext]="{
          $implicit: slide.slideData
        }"></ng-template>
        }
    </div>
    }
</ng-template>